import React from "react"

export default function WhitePanel({ children }) {
  return (
    <div className="flex flex-wrap bg-white p-4 rounded-lg shadow-lg mb-4">
      <div className="w-full px-4 ">{children}</div>
    </div>
  )
}
